import React from "react";

export default function VotingTargetToggle({
  cCode,
  uid,
  target,
  updateTarget
}) {
  return (
    <div
      className="btn-group"
      role="group"
      aria-label="Basic example"
      onClick={() => updateTarget(cCode, uid)}
    >
      <button
        type="button"
        className={`btn btn-sm btn-${target ? "primary" : "outline-primary"}`}
      >
        yes
      </button>
      <button
        type="button"
        className={`btn btn-sm btn-${target ? "outline-danger" : "danger"}`}
      >
        no
      </button>
    </div>
  );
}
